<!-- header search & filters -->
<section class="home-advance-search" [ngClass]="{ '!mt-6': wFull() }">
  <!-- header search input -->

  <form
    class="home-advance-search__fields-container"
    [formGroup]="searchForm"
    (submit)="submitSearchForm()">
    <pwj-input
      placeholder="global.search"
      class="home-advance-search__search-field"
      type="text"
      variant="default"
      [ngClass]="{ '!w-full': wFull() }"
      formControlName="searchTerm"></pwj-input>
    <button class="home-advance-search__search-btn" type="submit">
      <i class="iconsax search-icon" icon-name="search-normal-2"></i>
    </button>
  </form>
  <!-- header filters btn -->
  <!--  -->
  <div class="home-advance-search__options">
    <!-- -------------!!!!!!! for future - commented temporary !!!!!!!------------- -->
    <!-- search by voice btn -->
    <!-- <button class="home-advance-search__voice-btn">
      <pwj-text-summarizer
        [text]="'global.comingSoon' | translate"
        [limitLength]="0"
        [justTooltip]="true">
        <i class="iconsax option-icon" icon-name="mic-2"></i>
      </pwj-text-summarizer>
    </button> -->
    <!-- search by photo btn -->
    <!-- <button class="home-advance-search__photo-btn">
      <pwj-text-summarizer
        [text]="'global.comingSoon' | translate"
        [limitLength]="0"
        [justTooltip]="true">
        <i class="iconsax option-icon" icon-name="camera"></i>
      </pwj-text-summarizer>
    </button> -->

    <!-- advanced filters btn -->
    <button
      class="home-advance-search__filters"
      (click)="toggleAdvancedFilters()">
      <i
        class="iconsax filters-icon"
        [attr.icon-name]="hiddenAdvancedFilters ? 'setting-3' : 'x'"></i>
      <span class="filters-text">
        {{ 'global.advanceSearch' | translate }}
      </span>
    </button>
  </div>
</section>
